module.exports = __webpack_public_path__ + "assets/webgl/LM_1_0.jpg.dcfdad93.webp";